
import http from '@/util/http'
// 待配货根据条件模糊查询(分页)
export function queryByProcessState (type, page, size, data) {
  return http({
    url: `/api/orderContractStockup/queryByProcessState/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 根据ocsId和备货方式获取待配货清单
export function queryOrderContractStockupAllVo (psbId) {
  return http({
    url: `/api/orderContractStockup/queryOrderContractStockupAllVo/${psbId}`,
    method: 'post'
  })
}
// 配货详情-查看结果
export function queryByOrderContractStockupStorage (psbId) {
  return http({
    url: `/api/orderContractStockup/queryByOrderContractStockupStorage/${psbId}`,
    method: 'post'
  })
}
// 提交配货
export function addOrderContractStockupPurchase (data) {
  return http({
    url: '/api/orderContractStockup/addOrderContractStockupPurchase',
    method: 'post',
    data: data
  })
}
// 供应商充值记录
export function queryPurchaseSupplierBySuId (page, size, data) {
  return http({
    url: `/api/supplierRechargeApproval/queryPurchaseSupplierBySuId/${page}/${size}`,
    method: 'post',
    data: data
  })
}
